module.exports = __webpack_public_path__ + "img/05.6420d6d7.jpg";